import { SET_FOLLOWUPS } from "../actions/followUpActions";

const initialState = {
  followUps: [],
};

const followUpReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FOLLOWUPS:
      return {
        followUps: action.payload,
      };

    default:
      return state;
  }
};

export default followUpReducer;
